import { getMembersFromRootMember } from './tactonService';
import { getMembersFromRootMemberSummary } from './summaryService';
import {
  currentSegmentSelectionMembers,
  currentSegmentSeriesMembers
} from './cadService';

import { configuratorService } from './configuratorService';

const createPartNumberListofSegments = async (
  response,
  sessionData,
  activeTab
) => {
  var segmentParts = [];
  var segmentPart;
  var parts = [];
  var part;
  var orderSummaryMembers = [];
  let steps = await getManifoldOrderSummarySteps(
    response,
    sessionData,
    activeTab
  );
  response = assignOrderSummarySteps(response, steps);
  var manifoldOrderSummary = response.tactonModel.steps.filter(
    x => x.available == true && x.name.includes('order_summary_group')
  );
  if (!manifoldOrderSummary[0].hasOwnProperty('rootGroup')) return;
  var summaryRootGroupMembers =
    manifoldOrderSummary[0].rootGroup.members.filter(x =>
      x.name.includes('summary_group')
    );
  segmentParts = [];
  for (var i = 0; i < summaryRootGroupMembers.length; i++) {
    orderSummaryMembers = getMembersFromRootMemberSummary(
      summaryRootGroupMembers[i]
    );
    if (orderSummaryMembers.length > 0) {
      segmentPart = new Object();
      if (i == 0) {
        segmentPart.segmentName = 'ASSEMBLY';
        parts = [];
        part = new Object();
        part.description = orderSummaryMembers[0].description;
        part.value = orderSummaryMembers[0].value;
        parts.push(part);
      } else {
        segmentPart.segmentName = summaryRootGroupMembers[i].description;
        parts = [];
        for (let childSummaryMembers of orderSummaryMembers) {
          part = new Object();
          part.description = childSummaryMembers.description;
          part.value = childSummaryMembers.value;
          parts.push(part);
        }
      }
      segmentPart.partNumbers = parts;
      segmentParts.push(segmentPart);
    }
  }
  return segmentParts;
};

const createManifoldAssemblyCommits = response => {
  var availableSteps = response.tactonModel.steps.filter(
    x =>
      x.available == true &&
      !x.name.includes('initial_step') &&
      !x.name.includes('order_summary')
  );
  var uiRootGroupMembers = [];
  var uiMembers = [];
  var manifoldCommits = [];
  var manifoldCommit;
  var controls = [];
  var control;
  for (let step of availableSteps) {
    if (step.name.includes('manifold')) {
      uiRootGroupMembers = step.rootGroup.members.filter(
        x =>
          x.name.includes('ui_group') &&
          (!x.properties || x.properties.hidden != 'yes')
      );
      if (uiRootGroupMembers.length > 0) {
        controls = [];
        manifoldCommit = new Object();
        manifoldCommit.segmentName = 'manifold';
        if (uiRootGroupMembers.length > 0) {
          for (let uiRootMember of uiRootGroupMembers) {
            uiMembers = getMembersFromRootMember(uiRootMember);
            uiMembers = uiMembers.filter(
              x => !x.properties || x.properties.hidden != 'yes'
            );
            for (var i = 0; i < uiMembers.length; i++) {
              control = new Object();
              control.key = uiMembers[i].name;
              control.value = uiMembers[i].value;
              controls.push(control);
            }
          }
          manifoldCommit.commits = controls;
          manifoldCommits.push(manifoldCommit);
        }
      }
    } else if (step.name.includes('segment')) {
      var allSegments = response.segmentStep.rootGroup.members.filter(
        x => x.name.includes('segment') && x.hasVisibleParameters
      );
      for (let segment of allSegments) {
        uiMembers = [];
        controls = [];
        manifoldCommit = new Object();
        manifoldCommit.segmentName = segment.name;
        if (!segment.name.includes('segment_init'))
          uiMembers = currentSegmentSeriesMembers(segment);
        uiMembers.push(...currentSegmentSelectionMembers(segment));
        uiMembers = uiMembers.filter(
          x => !x.properties || x.properties.hidden != 'yes'
        );
        for (var i = 0; i < uiMembers.length; i++) {
          control = new Object();
          control.key = uiMembers[i].name;
          control.value = uiMembers[i].value;
          controls.push(control);
        }
        manifoldCommit.commits = controls;
        manifoldCommits.push(manifoldCommit);
      }
    }
  }
  return manifoldCommits;
};

const getManifoldOrderSummarySteps = async (
  response,
  sessionData,
  activeTab
) => {
  var StepIndex = response.tactonModel.steps.findIndex(
    x => x.name.includes('order_summary') && x.available == true
  );
  if (StepIndex > -1) {
    let requestData = {
      divisionId: sessionData?.manufacturingDivision,
      productId: '',
      configState: response.configState,
      key: '',
      configModel: sessionData.configModel,
      step: response?.tactonModel.steps[StepIndex].name,
      activeTab: activeTab //,
      //tactonModel: response?.tactonModel
    };

    let summaryStep = await configuratorService(requestData);
    return summaryStep?.tactonModel.steps;
  }
};

const assignOrderSummarySteps = (response, steps) => {
  var StepIndex = response.tactonModel.steps.findIndex(
    x => x.name.includes('order_summary') && x.available == true
  ); //summary
  if (StepIndex > -1) {
    response.tactonModel.steps[StepIndex] = steps[StepIndex];
    response.tactonModel.steps[StepIndex].current = false;
  }
  return response;
};

export {
  createPartNumberListofSegments,
  createManifoldAssemblyCommits,
  getManifoldOrderSummarySteps
};
